
export default {
  jobList: [],
  filterHeight: 0,
  filters: []
}
